/**
 * src/components/directory-page/SilverSection.js
 *
 * Sección "Negocios — Plan Plata".
 * Fetchea /data/businesses.json directamente para reflejar cambios del admin.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal, effect } from '@core/signal.js'

const isActive = b => {
    if (b.enabled === false) return false
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return false
    if (b.activeTo   && new Date(b.activeTo)   < now) return false
    return true
}

define('SilverSection', ({ initialCategory = '', categorySignal } = {}) => {
    const searchTerm = signal('')
    const baseItems  = signal([])
    const filtered   = signal([])

    effect(() => {
        const base = baseItems.get()
        const term = searchTerm.get()
        const cat  = categorySignal ? categorySignal.get() : initialCategory
        const src  = cat ? base.filter(b => b.categorySlug === cat) : base
        filtered.set(
            term ? src.filter(b =>
                b.name.toLowerCase().includes(term) ||
                b.category.toLowerCase().includes(term)
            ) : src
        )
    })

    /* Buscador */
    const input = h('input', {
        type: 'text', className: 'feat-filters__search-input',
        placeholder: 'Buscar negocio...'
    })
    input.addEventListener('input', () => searchTerm.set(input.value.trim().toLowerCase()))

    const searchWrap = h('div', { className: 'feat-filters__search' }, h('span', {}, '🔍'), input)

    /* Lista reactiva */
    const list  = h('div', { className: 'silver-list' })
    const empty = h('div', { className: 'biz-grid__empty' },
        h('span', { className: 'biz-grid__empty-icon' }, '🔍'),
        h('p', {}, 'No se encontraron negocios.')
    )

    effect(() => {
        while (list.firstChild) list.removeChild(list.firstChild)
        const items = filtered.get()
        if (!items.length) { list.appendChild(empty); return }
        items.forEach(biz => list.appendChild(c('SilverCard', biz)))
    })

    const counter = h('p', { className: 'feat-section__count' })
    effect(() => {
        const n = filtered.get().length
        counter.textContent = `${n} negocio${n !== 1 ? 's' : ''} encontrado${n !== 1 ? 's' : ''}`
    })

    /* Fetch directo con cache buster */
    fetch(`/data/businesses.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            baseItems.set((data.items || []).filter(b => b.plan === 'plata' && isActive(b)))
        })
        .catch(() => {})

    return h('section', { className: 'silver-section' },
        h('div', { className: 'silver-section__inner' },
            h('div', { className: 'feat-section__head' },
                h('div', { className: 'feat-section__titles' },
                    h('span', { className: 'silver-section__label' }, '🥈 Plan Plata'),
                    h('h2',  { className: 'feat-section__headline' }, 'Más negocios en Fusagasugá'),
                    h('p',   { className: 'feat-section__desc' },
                        'Negocios locales que también forman parte de la comunidad UBIYAAA.')
                ),
                counter
            ),
            h('div', { className: 'feat-filters silver-section__filters' }, searchWrap),
            list
        )
    )
})
